import { CareMapState } from '../caremap/CareMapState';

export class CareTabsProvider {

    static inject = () => [CareMapState];
    constructor(private careMapState: CareMapState) {}

    getTabs = () => {
        const careMap = this.careMapState.getActiveCaremap();
        if (!careMap) {
            throw new Error('No active care map!');
        }
        return {
            tabGroupId: 'care-tabs',
            tabs: [
                { label: 'Profile', url: `/care/${careMap.careMapId}`, dataId: 'profile-tab' },
                { label: 'Care Map', url: `/caremaps/${careMap.careMapId}`, dataId: 'caremap-tab' },
                { label: 'Notes', url: `/notes/${careMap.careMapId}`, dataId: 'notes-tab' }
            ]
        };
    };
}
